import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installSessionExpiryHandler } from './utils/sessionFetch';

serviceWorkerRegistration.register();

installSessionExpiryHandler(() => {
  window.localStorage.removeItem('token');
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer position="top-right" autoClose={3000} />
  </React.StrictMode>
);
